import { Decimal } from 'decimal.js';
/**
 * Isolated Decimal constructor for all money and quantity arithmetic.
 * precision 34 is IEEE 754 decimal128-like: far beyond numeric(20,5) values and the products
 * of quantity × price, so intermediate results are exact. Rounding happens only at explicit
 * points (see `roundAmount`), never implicitly.
 */
export const Dec = Decimal.clone({
    precision: 34,
    rounding: Decimal.ROUND_HALF_UP,
    toExpNeg: -40,
    toExpPos: 40,
});
/** ETA invoice v1.0: amounts, quantities and rates are carried with 5 decimal places. */
export const ETA_SCALE = 5;
const DECIMAL_STRING = /^-?\d{1,15}(\.\d{1,5})?$/;
/** Parses a decimal from a string. Rejects JS numbers to keep floating point out of money paths. */
export function dec(value) {
    if (value instanceof Dec)
        return value;
    if (typeof value !== 'string' || !DECIMAL_STRING.test(value)) {
        throw new TypeError(`Invalid decimal string: ${JSON.stringify(value)}`);
    }
    return new Dec(value);
}
/** Rounds to the ETA scale. The mode is explicit and versioned via RoundingPolicy. */
export function roundAmount(value, policy = DEFAULT_ROUNDING) {
    return value.toDecimalPlaces(policy.scale, policy.mode);
}
/** Canonical string with exactly `scale` decimals (e.g. "100.00000"), as stored and sent. */
export function toFixedScale(value, scale = ETA_SCALE) {
    return value.toFixed(scale);
}
export function sum(values) {
    return values.reduce((acc, v) => acc.plus(v), new Dec(0));
}
/**
 * Default policy: half-up at 5 decimals.
 * UNVERIFIED against ETA's validator; see docs/eta/ETA_INTEGRATION.md and ADR-0007.
 */
export const DEFAULT_ROUNDING = {
    id: 'eta-v1-half-up-5',
    scale: ETA_SCALE,
    mode: Decimal.ROUND_HALF_UP,
};
//# sourceMappingURL=money.js.map